import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import { post_api_call } from "../actions/action-creators/common";
// import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyD84dO-sAzr6nK_eddT8kfk9zfdogXA7wc",
  authDomain: "ifspd-6cb64.firebaseapp.com",
  projectId: "ifspd-6cb64",
  storageBucket: "ifspd-6cb64.firebasestorage.app",
  messagingSenderId: "529159229398",
  appId: "1:529159229398:web:cb7c7f4e264310a7449e77",
  measurementId: "G-E6DT16CQBM"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const messaging = getMessaging(app);
// const analytics = getAnalytics(app);

//Request Notification Permission
export const requestNotifyPermission = async() => {
    try{
        const permission = await Notification.requestPermission();
        console.log(permission, 'permission')
        if(permission === 'granted'){
            console.log('llllll', 'ttttttt')
            // const token = await getToken(messaging, { vapidKey: "BKGLOmSTZX3U7-lP21P4gnp3avG3LR9PqrxNLR78qnt8xfWW76Ws4xGAFVsy93yVDSY-h33q-WEmrQKcb4lKMCg"});
            // console.log(token, 'ttttttt5555')
            if(!localStorage.getItem("firebase_token")){
                const tokenData = await getFirebaseToken();
                console.log(tokenData, 'tokenData');
                //Store on the Server
                if(tokenData){
                    const tokenAPIData = await post_api_call('firebase/store-token', {token: tokenData}, false);
                    if(tokenAPIData.status === 200){
                        localStorage.setItem("firebase_token", tokenData);
                    }
                }
            }
        }
    }catch(error){

    }
}

export const getFirebaseToken = async() => {
    try{
        const token = await getToken(messaging, { vapidKey: "BKGLOmSTZX3U7-lP21P4gnp3avG3LR9PqrxNLR78qnt8xfWW76Ws4xGAFVsy93yVDSY-h33q-WEmrQKcb4lKMCg"});
        console.log(token, 'lllllll')
        return token;
    }catch(error){
        console.error(error);
        return '';
    }
}